import React, {Component} from 'react';
import {Modal, Table} from 'react-bootstrap';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import FlatButton from 'material-ui/FlatButton';

var Config = require('../../../config');

class ModalAuth extends Component{
	constructor(props){
		super(props);

		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.onSave = this.onSave.bind(this);
		this.handleChange = this.handleChange.bind(this);

		this.state = {
			show: false,
			user:"",
			pass:""
		}
	}

	componentDidMount(){
		this.props.onRef(this);
	}

	componentWillUnmount(){
		this.props.onRef(null);
	}

	handleChange(e){
		this.setState({
			[e.target.name]: e.target.value
		});

		if(e.target.value !== ""){
			this.showInputError(e.target.name);
		}
	}

	handleShow(){
		this.setState({
			show:true,
			user:sessionStorage.getItem('user_name')
		});
		
	}

	handleClose(){
		this.setState({
			show: false,
			user:"",
			pass:""
		});
	}

	isValidForm() {
		const select = document.querySelector('div.modal-body');
  		const inputs = select.querySelectorAll('input');
	    //const inputs = document.querySelectorAll('input');
	    let isFormValid = true;
	    inputs.forEach(input => {
	    	if(input.required){
		      	const isInputValid = this.showInputError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		  	}
	    });	  
	    
	    return isFormValid;
	}

	showInputError(refName) {
		const control = document.getElementById(refName);
		
		if(control.value === ""){
			if(control !== null){
	            control.classList.add('error');
	        }
			return false;
		}else{
			if(control.className.includes('error')){
				control.classList.remove('error');
			}
			return true;
		}
	}

	onSave(e){
		
		if(this.isValidForm()){
			var password = btoa(this.state.pass);
			password = password.split("").reverse().join("");

			var apiUrl = 'users/verify_pass';
			var obj = {
				username:this.state.user,
				password:password
			};
			
			this.props.waiting.handleShow('Autorizando...');
			fetch(Config.default.apiGateway.URL+apiUrl,{
				method:'POST',
				body:JSON.stringify(obj),
				headers: new Headers({
					'Authorization' : 'Bearer '+sessionStorage.getItem('token'),
					'Accept'		: 'application/json',
					'Content-Type'	: 'application/json'
				})
			}).then(res => {
				this.props.waiting.handleClose();
				if(res.ok){
					return res.json();
				}else{
					res.text().then((msg)=>{
						swal('Error', msg, 'error');
					});
				}
			}).then(response => {
				if(response !== undefined){
					if(this.props.reason !== ""){
						this.props.onSave();
						this.handleClose();
					}else{
						swal('Error', 'Debe igresar un motivo por el cual no se envian todas las unidades', 'error');
					}
				}
			})
			
		}else{
			swal('Error', 'Campos incompletos', 'error');
		}	
	}

	render(){
		const {t} = this.props;
		return (
			<Modal show={this.state.show} onHide={this.handleClose}>
				<Modal.Header>
					<Modal.Title>No está enviando el total de las unidades captadas. Para continuar, ingrese un motivo</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="row">
						<div className="col-xs-12">
							<div className="col-xs-12 col-sm-8 col-sm-offset-2">
								<div className="col-xs-12">
									<span className="span-min">Usuario</span>
									<input type="text" name="user" id="user" value={this.state.user || ""} disabled={this.state.screen === 'laboratory'}
										onChange={this.handleChange} className="form-control" autoComplete="none" required disabled/>
									
								</div>
								<div className="col-xs-12">
									<span className="span-min">Contraseña</span>
									<input type="password" name="pass" id="pass" value={this.state.pass}
										onChange={this.handleChange} className="form-control" autoComplete="none" required/>
								</div>

								<div className="col-xs-12">
									<span className="span-min">Motivo</span>
									<input type="text" name="reason" id="reason" value={this.props.reason}
										onChange={this.props.handleChange} className="form-control" autoComplete="none" required/>
								</div>
							</div>
						</div>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<FlatButton primary={true} label={t('content.generics.buttons.save')} 
						onClick={this.onSave} /> 
					<FlatButton primary={true} label={t('content.generics.buttons.close')} 
						onClick={this.handleClose} /> 
				</Modal.Footer>
			</Modal>
		)
			
	}
}

export default translate('translations') (ModalAuth)